export default "__VITE_ASSET__kjf1ysOy__"